/**
 * Servicio para verificación de eventos de usuarios.
 *
 * Este módulo contiene servicios para la verificación de eventos asociados
 * a un usuario mediante su documento de identidad (DNI).
 *
 * @author Victor Manuel Calle Londoño <victor.calle@iudigital.edu.co>
 * @date 2025-10-22
 * @updated 2025-10-22
 * @updatedBy Victor Manuel Calle Londoño <victor.calle@iudigital.edu.co>
 */

import fetchWrapper from "fetchWrapper";

/**
 * Obtiene todos los eventos (carnets) asociados a un documento de usuario.
 * Consulta el endpoint para obtener los carnets de eventos del usuario
 * basándose en su número de documento de identidad.
 *
 * @param {string} document - Número de documento de identidad del usuario.
 * @param {number} pageIndex - Índice de página para paginación (por defecto 1).
 * @returns {Object} Objeto con {payload} si es exitoso, {status: false, message} si hay error.
 */
const getAllEventsPerDocument = async (document, pageIndex = 1) => {
  try {
    const response = await fetchWrapper(
      `${process.env.REACT_APP_API_URL}/cards/cards_per_document_user_carnets/${document}?page=${pageIndex}`
    );

    if (response.status === 429) {
      const message =
        "Se ha excedido el límite de solicitudes al servidor. Por favor, inténtelo de nuevo más tarde.";
      const status = false;
      return { status, message };
    }

    const result = await response.json();
    const { success } = result;

    if (success === true) {
      const { payload } = result;
      return result;
    } else if (success === false) {
      const message = result.message || "Error del servidor al realizar la solicitud";
      const status = false;
      return { status, message };
    }
  } catch (error) {
    const message = error.message || "Error del servidor al realizar la solicitud";
    const status = false;
    return { status, message };
  }
};

export { getAllEventsPerDocument };
